<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="backButtonRoute ? true : false"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    :selectedIndex="selectedIndex"
    ref="gc-base-layout"
    class="intake-estimate"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Intake Estimate'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="
          baseView.mode == 'create'
            ? 'Create Intake Estimate'
            : 'Intake Estimate'
        "
        :secondaryLabel="
          baseView.mode != 'create' ? model.Description : undefined
        "
        v-if="loaded"
      />
    </template>

    <div class="css-v2 transaction-screen" v-if="loaded">
      <div class="gc-header-toolbar">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="loaded ? model : {}"
          :itemSaveCallBack="checkHeaderFormValidation"
          :backRoute="backButtonRoute"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
        ></gc-form-header-toolbar>
      </div>

      <div class="gc-header-form" v-show="!gridExpand">
        <div class="view-card responsive-paddings">
          <gc-form
            :formOptions="{
              gcLabelLocation: 'left',
            }"
            :formItems="getHeaderFormItems"
            :isNormal="true"
            :data-model="loaded ? model : {}"
            :formMode="baseView.mode"
            :fromFrom="'gc-header-form'"
            ref="gc-header-form"
            :valueChangeCallBack="headerFormValueChanged"
            :checkValid="isValid"
            :validationGroup="'gc-header-form'"
            :scrollingEnabled="false"
            :formContentReady="onHeaderFormContentReady"
            :formHeight="90"
          ></gc-form>
        </div>
      </div>

      <div class="gc-details-grid" v-if="loaded && IsGridDataLoaded">
        <dx-data-grid
          v-if="IsGridDataLoaded"
          @toolbar-preparing="toolbarPreparing($event)"
          :columns="getColumns"
          :data-source="getDataSource"
          :height="getGridHeight"
          @cell-prepared="onCellPrepared"
          :ref="'dx-data-grid-comp'"
          :key-expr="'VarietyCode'"
          @editor-preparing="onEditorPreparing"
          :twoWayBindingEnabled="false"
          :repaintChangesOnly="true"
          :focusedRowEnabled="baseView.mode != 'review'"
          :columnChooser="{
            enabled: false,
          }"
          :onFocusedCellChanging="onFocusedCellChanging"
        >
          <DxEditing
            :allow-updating="baseView.mode != 'review'"
            :allow-deleting="false"
            mode="cell"
            :new-row-position="'last'"
          />

          <DxKeyboardNavigation
            :edit-on-key-press="true"
            :enter-key-action="'startEdit'"
            :enter-key-direction="'none'"
            :enabled="true"
          />
        </dx-data-grid>
      </div>
    </div>

    <!-- Apply Size Profile -->
    <gc-popup
      :popup-visible="visibleApplySizeProfile"
      popup-title="Apply Size Profile"
      :back-button-function="closeApplySizeProfile"
      :popup-height="200"
      :saveButtonConfig="ApplySizeProfileConfig.save"
      :backButtonConfig="ApplySizeProfileConfig.back"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="{
            gcLabelLocation: 'left',
          }"
          :formItems="getApplySizeProfileFormItems"
          :isNormal="true"
          :data-model="ApplySizeProfileModel"
          :formMode="'create'"
          :fromFrom="'gc-header-form-d-a'"
          :formHeight="70"
          :validationGroup="'gc-header-form-d-a'"
        ></gc-form>
      </div>
    </gc-popup>

    <!-- Volume/Percentage Entry Popup -->
    <gcPopupVolumePercentageEntry
      :visible="visibleVolumePercentageEntry"
      @setVisible="visibleVolumePercentageEntry = $event"
      @updateSizeValues="handleUpdateSizeValues"
      :selectedRow="selectedRow"
      :columns="sizeColumns"
      :popupConfig="getPopupConfig"
      v-if="visibleVolumePercentageEntry"
    />
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { mapGetters } from "vuex";
import { IntakeEstimateService } from "../../../_services/api/purchasing/intake-estimate/intake-estimate.service";
import { UserService } from "../../../_services/api/settings/user/user.service";
import ArrayStore from "devextreme/data/array_store";
import validationEngine from "devextreme/ui/validation_engine";
import { IntakeSeasonService } from "../../../_services/api/settings/inventory/intake-season.service";
import { backwardTabbing, forwardTabbing } from "../../../_helpers/ui/keyboard";

import gcPopupVolumePercentageEntry from "../../../popups/purchasing/gc-popup-volume-percentage-entry";
import SettingsService from "../../../_services/api/settings/graycorp/settings.service";

export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    gcPopupVolumePercentageEntry,
  },
  data() {
    return {
      backButtonRoute: "/intake-estimate",
      loaded: false,
      gridExpand: false,
      isValid: false,
      model: {
        Status: "N",
        Description: undefined,
        Season: null,
        EstimateDate: undefined,
        EstimateOwner: UserService.getUsername(),
        TotalKg: 0,
        TotalTons: 0,
        Narration: undefined,
      },
      headerFormHeight: 0,
      columns: [],

      dataSource: new ArrayStore({
        key: "VarietyCode",
        data: [],
      }),
      selectedSeason: undefined,
      visibleApplySizeProfile: false,
      ApplySizeProfileModel: {
        Season: undefined,
      },
      IsGridDataLoaded: false,
      visibleVolumePercentageEntry: false,
      selectedRow: undefined,
      sizeColumns: [],
      popupConfig: undefined,
      defaultReclaimPercent: 0,
    };
  },
  created() {
    this.onInitialized();
  },
  methods: {
    // This function is used to close the Apply Size Profile modal (or any similar component)
    // and reset the Season property of the ApplySizeProfileModel object.
    closeApplySizeProfile() {
      // Set the visibility of the Apply Size Profile modal (or similar) to false, effectively hiding it.
      this.visibleApplySizeProfile = false;

      // Reset the Season property of the ApplySizeProfileModel object to undefined.
      this.ApplySizeProfileModel.Season = undefined;
    },
    // This function is used to open the Apply Size Profile modal (or any similar component).
    openApplySizeProfile() {
      // Set the visibility of the Apply Size Profile modal (or similar) to true, effectively showing it.
      this.visibleApplySizeProfile = true;
    },
    // This function is triggered when the editor is preparing to make changes.
    onEditorPreparing(e) {
      // Check if the parent type is a data row.
      if (e.parentType == "dataRow") {
        // If the data field does not exist in the row data, disable the editor.
        // if (!(e.dataField in e.row.data)) e.editorOptions.disabled = true;

        if (e.dataField == "StartDate") {
          let func = e.editorOptions.onKeyDown;
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
        }
      }
    },

    // This function is triggered when a cell is prepared.
    onCellPrepared(e) {
      // If the row type is data, perform the following operations.
      if (e.rowType == "data") {
        // If the column data field does not exist in the data, remove the "gc-editable-cell-color" class from the cell element.
        if (!(e.column.dataField in e.data)) {
          e.cellElement.classList.remove("gc-editable-cell-color");
        }
      }

      // If the mode is "review", remove the "gc-editable-cell-color" class from the cell element.
      if (e.rowType == "data") {
        if (this.baseView.mode == "review")
          e.cellElement.classList.remove("gc-editable-cell-color");
        else if (e.column.dataField in e.data && e.column.allowEditing) {
          e.cellElement.classList.add("gc-editable-cell-color");
        }
      }
    },

    // This function is triggered when the focused cell is changing.
    onFocusedCellChanging(e) {
      if (!e.event) return;
      // Check if the tab key was pressed without the shift key.
      if (e.event.code == "Tab" && e.event.shiftKey == false) {
        let dataField = e.columns[e.newColumnIndex].dataField;
        // If the data field does not exist in the row data, increment the new column index.
        if (!(dataField in e.rows[e.newRowIndex].data)) {
          e.newColumnIndex += 1;

          let colCount = e.columns.length;
          // Check if the next consecutive columns also have disabled editing.
          for (let i = e.newColumnIndex; i < colCount; i++) {
            dataField = e.columns[e.newColumnIndex].dataField;
            // If the data field does not exist in the row data, increment the new column index.
            if (!(dataField in e.rows[e.newRowIndex].data)) {
              e.newColumnIndex += 1;
            } else {
              break;
            }
          }
        }
        // Check if the tab key was pressed with the shift key.
      } else if (e.event.code == "Tab" && e.event.shiftKey == true) {
        let dataField = e.columns[e.newColumnIndex].dataField;
        // If the data field does not exist in the row data, decrement the new column index.
        if (!(dataField in e.rows[e.newRowIndex].data)) {
          e.newColumnIndex -= 1;

          let colCount = e.columns.length;
          // Check if the next consecutive columns also have disabled editing.
          // eslint-disable-next-line for-direction
          for (let i = e.newColumnIndex; i < colCount; i--) {
            dataField = e.columns[e.newColumnIndex].dataField;
            // If the data field does not exist in the row data, decrement the new column index.
            if (!(dataField in e.rows[e.newRowIndex].data)) {
              e.newColumnIndex -= 1;
            } else {
              break;
            }
          }
        }
      }
    },
    toolbarPreparing() {},

    // This function checks the validation of the header form.
    async checkHeaderFormValidation() {
      // Validate the toolbar form.
      let toorBarForm = await validationEngine.validateGroup(
        "gc-form-header-toolbar"
      );
      // Validate the header form.
      let headerform = await validationEngine.validateGroup("gc-header-form");
      // Validate Kernel column matches sum of size columns
      let kernelValidationErrors = [];
      this.dataSource._array.forEach((row) => {
        if (row.KernelVolume) {
          let sizeSum = 0;
          this.sizeColumns.forEach((col) => {
            sizeSum += row[col.dataField] || 0;
          });

          // Allow small floating point differences (0.01 tolerance)
          const difference = Math.abs(row.KernelVolume - sizeSum);
          if (difference > 0.01) {
            kernelValidationErrors.push({
              message: `Variety ${
                row.VarietyCode
              }: Kernel value (${row.KernelVolume.toFixed(
                2
              )}) does not match sum of size columns (${sizeSum.toFixed(2)})`,
              validator: { name: "Kernel Validation" },
            });
          }
        }

        if (row.TotalKg > 0 && (!row.StartDate || !row.EndDate)) {
          kernelValidationErrors.push({
            message: `Variety ${row.VarietyCode}: Start Date and End Date are required when Total Kg is greater than zero.`,
            validator: { name: "Date Validation" },
          });
        }

        if (
          ((row.ReclaimPercent !== 0 &&
            row.ReclaimPercent !== this.defaultReclaimPercent) ||
            row.VarietyComplete) &&
          row.TotalKg === 0
        ) {
          kernelValidationErrors.push({
            message: `Variety ${row.VarietyCode}: Missing total or size values.`,
            validator: { name: "Missing Value Validation" },
          });
        }
      });

      if (
        !toorBarForm.isValid ||
        !headerform.isValid ||
        kernelValidationErrors.length > 0
      ) {
        this.displayValidationSummary(
          toorBarForm.brokenRules
            .concat(headerform.brokenRules)
            .concat(kernelValidationErrors)
        );
      } else if (this.getEstimateVarieties().length == 0) {
        this.displayValidationSummary([
          {
            message: `At least one variety with Total Kg greater than zero is required.`,
            validator: { name: "Variety Validation" },
          },
        ]);
      } else {
        // Prepare the payload for the intake estimate.
        var payload = {
          Description: this.model.Description,
          Narration: this.model.Narration,
          Season: this.model.Season,
          EstimateDate: new Date(this.model.EstimateDate).toSaveDate(),
          EstimateOwner: this.model.EstimateOwner,
          TotalKg: this.model.TotalKg,
          EstimateVarieties: this.getEstimateVarieties(),
          EstimateSizes: this.getEstimateSizes(),
        };

        if (this.baseView.mode == "edit") payload.RecordId = this.baseView.id;

        // Show the loading indicator.
        this.showLoading(true);
        // Save the intake estimate.
        await IntakeEstimateService.saveIntakeEstimate(payload)
          .then((res) => {
            // If the response is successful, continue showing the loading indicator.
            if (res) this.showLoading(false);

            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: "/intake-estimate/review/" + res.data.RecordId,
            });
          })
          .catch((err) => {
            // If there is an error, continue showing the loading indicator and display the server error.
            this.showLoading(false);
            this.displayServerError(err, "Intake Estimate Save Failed");
          });
      }
    },

    // This function gets the estimate varieties.
    getEstimateVarieties() {
      // Initialize an empty array.
      var obj = [];
      // Iterate over each element in the data source array.
      this.dataSource._array.forEach((element) => {
        // If any of the specified properties exist, push a new object to the array.
        if (
          element.StartDate ||
          element.EndDate ||
          // element.LiftPcnt ||
          element.TotalKg
        ) {
          var item = {
            VarietyCode: element.VarietyCode,
            StartDate: element.StartDate,
            EndDate: element.EndDate,
            // LiftPcnt: element.LiftPcnt,
            TotalKg: element.TotalKg,
            ReclaimPercent: element.ReclaimPercent,
            Completed: element.VarietyComplete ? "Y" : "N",
          };

          if (this.baseView.mode != "create") {
            item.RecordId = element.RecordId;
            item.IntakeEstimateRecordID = element.IntakeEstimateRecordID;
          }
          obj.push(item);
        }
      });

      // Return the array.
      return obj;
    },

    // This function gets the estimate sizes.
    getEstimateSizes() {
      // Initialize an empty array.
      var obj = [];
      // Iterate over each element in the data source array.
      this.dataSource._array.forEach((element) => {
        // Iterate over each key in the element.
        for (var key in element) {
          var pattern = /RecordId/g;
          // If the key is not one of the specified properties and the key exists, push a new object to the array.
          if (
            key != "VarietyCode" &&
            key != "StartDate" &&
            key != "EndDate" &&
            // key != "LiftPcnt" &&
            key != "TotalKg" &&
            key != "IntakeEstimateRecordID" &&
            key != "KernelVolume" &&
            key != "VarietyComplete" &&
            key != "ReclaimPercent" &&
            key != "VarietyDescription" &&
            pattern.test(key) == false
          ) {
            if (element[key]) {
              var item = {
                VarietyCode: element.VarietyCode,
                SizeCode: key.toString(),
                TotalKg: element[key],
              };

              if (this.baseView.mode != "create") {
                item.RecordId = element[key + "_RecordId"];
                item.IntakeEstimateRecordID = element.IntakeEstimateRecordID;
              }
              obj.push(item);
            }
          }
        }
      });

      // Return the array.
      return obj;
    },

    // This function is triggered when the header form content is ready.
    onHeaderFormContentReady(e) {
      // Get all elements with the class "gc-header-form".
      const headerForm = document.querySelectorAll(".gc-header-form");
      // Set the height of the header form.
      this.headerFormHeight = headerForm[0].clientHeight;

      // If the event exists and the mode is not "review", set the focus to the "DateIn" editor after a delay.
      if (e && this.baseView.mode != "review") {
        setTimeout(() => {
          var headerToolBarForm = e.component;
          if (headerToolBarForm && headerToolBarForm.getEditor("DateIn"))
            headerToolBarForm.getEditor("DateIn").instance().focus();
        }, 500);
      }
    },

    // This function is triggered when the value of the header form changes.
    headerFormValueChanged(isValid, brokenRules) {
      // Set the validity to false.
      this.isValid = false;
      // If the form is not valid, display the validation summary.
      if (!isValid) this.displayValidationSummary(brokenRules);
    },

    // This function is triggered when the back button is clicked.
    backButtonFunction() {
      // Navigate to the route specified by the back button.
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          // Reset the data view type.
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },

    // This function is triggered when the component is initialized.
    async onInitialized() {
      await this.readApplicationSettings();
      // If the mode is "create", set the loaded flag to true.
      if (this.baseView.mode == "create") {
        // Development purpose only, to set default season
        // this.IsGridDataLoaded = true;
        // await this.loadVarietyANDSizeData();

        this.loaded = true;
      } else {
        this.popupConfig = {
          formMode: this.baseView.mode,
        };
        this.IsGridDataLoaded = true;
        // TO-DO this needs to update to filters based on season selection
        await this.loadVarietyANDSizeData();
        // Otherwise, get the intake estimate, intake estimate variety, and intake estimate size from the service.
        await IntakeEstimateService.getAlmondcoIntakeEstimate(
          this.baseView.id
        ).then((res) => {
          if (res.data.value.length > 0) {
            var data = res.data.value[0];
            // Update the model with the data from the response.
            this.model.Description = data.Description;
            this.model.Season = data.Season;
            this.model.EstimateDate = data.EstimateDate;
            this.model.EstimateOwner = data.EstimateOwner;
            this.model.TotalKg = data.TotalKg;
            this.model.DateChanged = data.DateChanged;
            this.model.DateCreated = data.DateCreated;
            this.model.ChangedBy = data.ChangedBy;
            this.model.CreatedBy = data.CreatedBy;
            this.model.TotalTons = data.TotalKg / 1000;
            this.model.Narration = data.Narration;
          }
        });

        await IntakeEstimateService.getAlmondcoIntakeEstimateVariety(
          this.baseView.id
        ).then((res) => {
          // For each element in the response, update the data source with the variety code and the data from the element.
          res.data.value.forEach((element) => {
            this.dataSource.update(element.VarietyCode, {
              StartDate: new Date(element.StartDate),
              EndDate: new Date(element.EndDate),
              // LiftPcnt: element.LiftPcnt,
              TotalKg: element.TotalKg,
              RecordId: element.RecordId,
              ReclaimPercent: element.ReclaimPercent,
              VarietyComplete: element.Completed === "Y" ? true : false,
            });
          });
        });

        await IntakeEstimateService.getAlmondcoIntakeEstimateSize(
          this.baseView.id
        ).then((res) => {
          // For each element in the response, update the data source with the variety code and the size and total kg from the element.
          res.data.value.forEach((element) => {
            var obj = {};
            var size = element.SizeCode;
            obj[size] = element.TotalKg;
            obj["IntakeEstimateRecordID"] = element.IntakeEstimateRecordID;
            obj[size + "_RecordId"] = element.RecordId;
            this.dataSource.update(element.VarietyCode, obj);
          });

          // After loading all sizes, calculate Kernel values for each row
          this.dataSource._array.forEach((row) => {
            let kernelValue = 0;
            this.sizeColumns.forEach((col) => {
              kernelValue += row[col.dataField] || 0;
            });

            if (kernelValue > 0) {
              this.dataSource.update(row.VarietyCode, {
                KernelVolume: kernelValue.roundNumber(2),
              });
            }
          });
        });

        // Set the loaded flag to true.
        this.loaded = true;
      }
    },

    // This function gets the available variety size from the IntakeEstimateService.
    async getAlmondcoIntakeAvailableVarietySize() {
      this.columns = [];
      this.sizeColumns = [];
      // Call the getAlmondcoIntakeAvailableVarietySize method from the service and wait for the response.
      await IntakeEstimateService.getAlmondcoIntakeAvailableVarietySize(
        this.baseView.id
      ).then((res) => {
        // For each element in the response data value, perform the following operations.
        // alphabetical order
        var data = res.data.value.sort((a, b) => {
          if (a.Size < b.Size) {
            return -1;
          }
          if (a.Size > b.Size) {
            return 1;
          }
          return 0;
        });

        data.forEach((element) => {
          // Push a new object to the columns array with properties set based on the element.
          const colObj = {
            caption: element.Size, // Set the caption to the size of the element.
            dataField: element.Size, // Set the data field to the size of the element.
            dataType: "number", // Set the data type to number.
            allowEditing: false, // Allow editing of this field.
            showEditorAlways: false, // Do not always show the editor.
            minWidth: 75, // Set the minimum width of the column to 75.
            // If the mode is not "review", set the cssClass to "gc-editable-cell-color", otherwise set it to undefined.
            cssClass: undefined,
            format: "##,###,###,###,##0", // Set the format for the number.
            editorOptions: {
              format: "##,###,###,###,##0", // Set the format for the editor.
              onFocusIn: (e) => {
                // If the event target has a select method, call it.
                if (e.event.target.select) e.event.target.select();
              },
            },
            setCellValue: async (newData, value, currentRowData) => {
              var dataField = element.Size;
              // const oldValue = currentRowData[dataField] || 0;
              newData[dataField] = value || 0;

              // Recalculate Kernel value by summing all size columns
              let newKernelValue = 0;
              this.sizeColumns.forEach((col) => {
                const sizeCode = col.dataField;
                if (sizeCode === dataField) {
                  newKernelValue += value || 0;
                } else {
                  newKernelValue += currentRowData[sizeCode] || 0;
                }
              });

              newData.KernelVolume = newKernelValue;

              // Calculate the new total kg
              newData.TotalKg = (currentRowData.Inshell || 0) + newKernelValue;

              this.updateTotalKgs(currentRowData.TotalKg, newData.TotalKg);

              return newData;
            },
          };
          if (element.Size != "Inshell") {
            this.columns.push(colObj);
            this.sizeColumns.push(colObj);
          }
        });

        this.columns.push({
          dataField: "",
          caption: "",
          type: "buttons",
          cssClass: "gc-grid-button-column",
          buttons: [
            {
              hint: "Volume/Percentage",
              icon: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 15L15 5M13.3333 14.1667C13.3333 14.3877 13.4211 14.5996 13.5774 14.7559C13.7337 14.9122 13.9457 15 14.1667 15C14.3877 15 14.5996 14.9122 14.7559 14.7559C14.9122 14.5996 15 14.3877 15 14.1667C15 13.9457 14.9122 13.7337 14.7559 13.5774C14.5996 13.4211 14.3877 13.3333 14.1667 13.3333C13.9457 13.3333 13.7337 13.4211 13.5774 13.5774C13.4211 13.7337 13.3333 13.9457 13.3333 14.1667ZM5 5.83333C5 6.05435 5.0878 6.26631 5.24408 6.42259C5.40036 6.57887 5.61232 6.66667 5.83333 6.66667C6.05435 6.66667 6.26631 6.57887 6.42259 6.42259C6.57887 6.26631 6.66667 6.05435 6.66667 5.83333C6.66667 5.61232 6.57887 5.40036 6.42259 5.24408C6.26631 5.0878 6.05435 5 5.83333 5C5.61232 5 5.40036 5.0878 5.24408 5.24408C5.0878 5.40036 5 5.61232 5 5.83333Z" stroke="#03A9F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>`,
              visible: true,
              onClick: async (e) => {
                const rowData = e.row.data || {};
                if (
                  rowData &&
                  !rowData.KernelVolume &&
                  this.baseView.mode != "review"
                ) {
                  await this.$alert("Kernel Volume is required.", "Validation");

                  this.moveCellFocus(e.row, "KernelVolume");
                } else {
                  this.onVisibleVolPrecentagePopup(e.row);
                }
              },
            },
          ],
          fixed: true,
          fixedPosition: "right",
          width: 40,
          minWidth: 40,
        });
      });
    },

    // This function updates the total kilograms in the form.
    updateTotalKgs(oldValue, newValue) {
      // Get the form instance from the component's refs.
      var form = this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;

      // Check if the form instance exists.
      if (form) {
        // Get the editor for the "TotalTons" field.
        var editor = form.getEditor("TotalTons");

        // Check if the editor exists.
        if (editor) {
          // Get the current value of "TotalTons".
          let totalTons = editor.option("value");

          // Update the value of "TotalTons" by subtracting the old value and adding the new value.
          // This is done to reflect the changes in the total tons based on the changes in the individual entries.
          if (oldValue != undefined) {
            editor.option(
              "value",
              totalTons - oldValue / 1000 + newValue / 1000
            );
            this.model.TotalKg = this.model.TotalKg - oldValue + newValue;
          } else {
            editor.option("value", newValue / 1000);
            this.model.TotalKg = newValue;
          }
        }
      }
    },

    // This function gets the variety size from the IntakeEstimateService.
    async getAlmondcoIntakeVarietySize() {
      // Call the getAlmondcoIntakeVarietySize method from the service and wait for the response.
      return await IntakeEstimateService.getAlmondcoIntakeVarietySize(
        this.baseView.id
      ).then((res) => {
        // Return the value from the response data.
        return res.data.value;
      });
    },

    // This function creates a data source from the given variety size.
    createDataSource(varietySize) {
      this.dataSource.clear();

      // Group the variety size items by code.
      let groupedItems = this.groupByCode(varietySize);

      // For each key in the grouped items, perform the following operations.
      for (var key in groupedItems) {
        // Create a new object with the key and some default properties.
        var obj = {
          VarietyCode: key,
          VarietyDescription: groupedItems[key][0].VarietyName,
          StartDate: "",
          EndDate: "",
          ReclaimPercent: this.defaultReclaimPercent,
          // LiftPcnt: "",
          TotalKg: 0,
          KernelVolume: null,
          Inshell: null,
          VarietyComplete: false,
        };

        // For each element in the grouped items, add a new property to the object with the size as the key and null as the value.
        groupedItems[key].forEach((element) => {
          var size = element.Size;
          if (size !== "Inshell") {
            obj[size] = null;
          }
        });

        // Insert the object into the data source.
        this.dataSource.insert(obj);
      }
    },

    // This function groups an array of items by code.
    groupByCode(array) {
      // eslint-disable-next-line no-unused-vars
      var groupedItems = [];
      return array.reduce((groupedItems, item) => {
        (groupedItems[item.Code] = groupedItems[item.Code] || []).push(item);
        return groupedItems;
      }, {});
    },

    // This function is triggered when a season is clicked.
    async onSeasonClicked(e) {
      // Set the selected season to the clicked item's data.
      this.selectedSeason = e.itemData;

      // // Get the instance of the form component.
      // var instance =
      //   this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;

      // // Get the editor for the "EstimateDate" field.
      // var editor = instance.getEditor("EstimateDate");

      // // Set the minimum and maximum options for the editor to the start and end dates of the selected season.
      // editor.option("min", new Date(this.selectedSeason.StartDate));
      // editor.option("max", new Date(this.selectedSeason.EndDate));
    },

    async onSeasonValueChanged(e) {
      if (!e.event) return;

      this.model.Season = e.value;
      if (!this.IsGridDataLoaded) {
        this.showLoading(true);
        await this.loadVarietyANDSizeData();
        this.$nextTick(() => {
          this.showLoading(false);
          this.IsGridDataLoaded = true;

          setTimeout(() => {
            this.focusOnFormElement("EstimateDate");
          }, 100);
        });
      }
    },

    async loadVarietyANDSizeData() {
      // Get the available variety size and the variety size from the service, then create the data source.
      await this.getAlmondcoIntakeAvailableVarietySize();
      var varietySize = await this.getAlmondcoIntakeVarietySize();
      this.createDataSource(varietySize);
    },

    // This function is used to apply a size profile.
    async onApplySizeProfile() {
      // Show the loading indicator.
      this.showLoading(true);

      // Call the ApplySizeProfile method from the IntakeEstimateService.
      await IntakeEstimateService.ApplySizeProfile(
        this.ApplySizeProfileModel.Season
      )
        .then((res) => {
          // Extract the data from the response.
          var data = res.data.value;

          // Iterate over each element in the data array.
          data.forEach((element) => {
            // Extract the size as a key.
            var key = element.Size;

            // Create an item object with the variety code and total kg.
            var item = {
              VarietyCode: element.Variety,
              TotalKg: element.VarietyKg,
            };

            // Add the size kg to the item object using the size as the key.
            item[key] = element.SizeKg;

            this.dataSource.byKey(item.VarietyCode).then((res) => {
              if (res.TotalKg) {
                res[key] = (res.TotalKg * item[key]) / item.TotalKg;
                // Update the data source with the new item.
                this.dataSource.update(res.VarietyCode, res);
              }
            });
          });

          // Get the instance of the data grid component.
          var dataGrid = this.$refs["dx-data-grid-comp"].instance;

          // If the data grid exists, refresh it.
          if (dataGrid)
            dataGrid.refresh(true).then(() => {
              // // Initialize a total variable.
              // var total = 0;
              // // Iterate over each data in the data source array.
              // this.dataSource._array.forEach((data) => {
              //   // console.log("AA >> ", data.TotalKg);
              //   // Add the total kg to the total variable.
              //   if (data.TotalKg) total = total + data.TotalKg;
              // });
              // // Update the total kgs.
              // this.updateTotalKgs(undefined, Math.round(total));
            });

          // Hide the loading indicator.
          this.showLoading(false);

          // Close the apply size profile modal.
          this.closeApplySizeProfile();
        })
        .catch((err) => {
          // If an error occurs, hide the loading indicator.
          if (err) this.showLoading(false);
        });
    },

    moveCellFocus(cellInfo, nextColumn) {
      let dataGrid = this.$refs["dx-data-grid-comp"].instance;
      if (dataGrid) {
        var rowIndex = cellInfo.rowIndex;
        var cellElement = dataGrid.getCellElement(rowIndex, nextColumn);
        dataGrid.focus(cellElement);
        setTimeout(() => {
          dataGrid.editCell(rowIndex, nextColumn);
        }, 10);
      }
    },

    focusOnFormElement(controlElementRef) {
      this.$nextTick(() => {
        let formInstance =
          this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;

        formInstance &&
          formInstance.getEditor(controlElementRef) &&
          formInstance.getEditor(controlElementRef).instance().focus();
      });
    },

    onVisibleVolPrecentagePopup(rowData) {
      this.selectedRow = rowData;
      this.visibleVolumePercentageEntry = true;
    },

    async handleUpdateSizeValues(payload) {
      const { varietyCode, sizeValues } = payload;

      // Get the current row data
      const currentRow = await this.dataSource.byKey(varietyCode);

      if (!currentRow) return;

      // Prepare update object with only size columns (exclude ID, Variety, Total, KernelVolume)
      const updateData = {};

      this.sizeColumns.forEach((col) => {
        const sizeCode = col.dataField;
        if (sizeValues[sizeCode] !== undefined) {
          // Set to null if value is 0, otherwise use the value
          updateData[sizeCode] =
            sizeValues[sizeCode] === 0 ? null : sizeValues[sizeCode];
        }
      });

      // Recalculate Kernel value
      let newKernelValue = 0;
      this.sizeColumns.forEach((col) => {
        newKernelValue += updateData[col.dataField] || 0;
      });

      // updateData.KernelVolume = newKernelValue;

      // Calculate the new total kg
      updateData.TotalKg = (currentRow.Inshell || 0) + newKernelValue.roundNumber(2);

      // Update the data source
      await this.dataSource.update(varietyCode, updateData);

      // Update the total KGs in the header
      this.updateTotalKgs(currentRow.TotalKg, updateData.TotalKg);

      // Refresh the grid
      const dataGrid = this.$refs["dx-data-grid-comp"].instance;
      if (dataGrid) {
        await dataGrid.refresh(true);
      }
    },

    async readApplicationSettings() {
      await SettingsService.getBySettingByApplicationFeatureCode(
        "AlmondIntakeEstimate"
      ).then((res) => {
        res.data.value.forEach((element) => {
          if (element.SettingName == "DefaultReclaimPercent") {
            if (element.ScopeCode == "Global") {
              if (element.SettingValue) {
                this.defaultReclaimPercent = parseFloat(element.SettingValue);
              }
            }
          }
        });
      });
    },
  },
  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),

    getApplySizeProfileFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              screenField: "EstimateSeason",
              dataField: "Season",
              editorType: "dxSelectBox",
              required: true,
              editorOptions: {
                tabIndex: 2,
                dataSource: IntakeSeasonService.dataSourceConfig(
                  "api/AlmondcoIntakeSeason",
                  {
                    select: ["Season", "RecordId", "StartDate", "EndDate"],
                    sort: "Season asc",
                  }
                ),
                displayExpr: "Season",
                valueExpr: "Season",
                searchExpr: ["Season"],
                searchMode: "contains",
                showClearButton: true,
                searchEnabled: true,
                dropDownOptions: {
                  minWidth: 200,
                },
                onItemClick: this.onSeasonClicked,
              },
            },
          ],
        },
      ];
    },
    ApplySizeProfileConfig() {
      return {
        save: {
          text: "Apply",
          disabled: !this.ApplySizeProfileModel.Season,
          clickCallback: async () => {
            await this.onApplySizeProfile();
          },
        },
        back: {
          text: "Cancel",
          clickCallback: async () => {
            this.closeApplySizeProfile();
          },
        },
      };
    },
    getGridHeight() {
      return this.gridHeight - 20 - 55 - this.headerFormHeight;
    },
    getDataSource() {
      return this.dataSource._array;
    },
    getColumns() {
      return [
        {
          caption: "Variety",
          dataField: "VarietyCode",
          fixed: true,
          allowEditing: false,
          minWidth: 85,
          sortIndex: 0,
          sortOrder: "asc",
        },
        {
          caption: "Start",
          dataField: "StartDate",
          allowEditing: true,
          dataType: "date",
          format: "dd MMM yyyy",
          editorOptions: {
            displayFormat: "dd MMM yyyy",
            useMaskBehavior: true,
            showClearButton: true,
            onKeyDown: (e, row) => {
              if (!e.event) return;

              if (backwardTabbing(e) && row.rowIndex === 0) {
                e.event.preventDefault();
                this.focusOnFormElement("Narration");
              }
            },
          },
          width: 110,
          setCellValue: (newData, value) => {
            newData.StartDate = value;
            return newData;
          },
          cssClass:
            this.baseView.mode != "review"
              ? "gc-editable-cell-color editable-date-cell"
              : undefined,
        },
        {
          caption: "End",
          dataField: "EndDate",
          allowEditing: true,
          dataType: "date",
          format: "dd MMM yyyy",
          editorOptions: {
            displayFormat: "dd MMM yyyy",
            useMaskBehavior: true,
            showClearButton: true,
          },
          width: 110,
          setCellValue: (newData, value) => {
            newData.EndDate = value;
            return newData;
          },
          cssClass:
            this.baseView.mode != "review"
              ? "gc-editable-cell-color  editable-date-cell"
              : undefined,
        },
        {
          caption: "Reclaim %",
          dataField: "ReclaimPercent",
          dataType: "number",
          allowEditing: true,
          format: "##0.00",
          editorOptions: {
            format: "##0.00",
            onFocusIn: (e) => {
              if (e.event.target.select) e.event.target.select();
            },
          },
          width: 70,
          cssClass:
            this.baseView.mode != "review"
              ? "gc-editable-cell-color"
              : undefined,
          setCellValue: (newData, value) => {
            newData.ReclaimPercent = value;
            return newData;
          },
        },
        {
          caption: "Complete",
          dataField: "VarietyComplete",
          dataType: "boolean",
          allowEditing: this.baseView.mode == "edit",
          width: 70,
          setCellValue: (newData, value) => {
            newData.VarietyComplete = value;
            return newData;
          },
        },
        {
          caption: "Inshell",
          dataField: "Inshell",
          dataType: "number",
          allowEditing: true,
          format: "##,###,###,###,##0",
          editorOptions: {
            format: "##,###,###,###,##0",
            onFocusIn: (e) => {
              if (e.event.target.select) e.event.target.select();
            },
          },
          minWidth: 110,
          cssClass:
            this.baseView.mode != "review"
              ? "gc-editable-cell-color"
              : undefined,

          setCellValue: (newData, value, currentRowData) => {
            const newInshellValue = value || 0;
            // const oldInshellValue = currentRowData.Inshell || 0;

            newData.Inshell = newInshellValue;
            newData.TotalKg =
              newInshellValue + (currentRowData.KernelVolume || 0);

            this.updateTotalKgs(currentRowData.TotalKg, newData.TotalKg);
            return newData;
          },
        },
        {
          caption: "Kernel",
          dataField: "KernelVolume",
          dataType: "number",
          allowEditing: true,
          format: "##,###,###,###,##0",
          editorOptions: {
            format: "##,###,###,###,##0",
            onFocusIn: (e) => {
              if (e.event.target.select) e.event.target.select();
            },
          },
          minWidth: 110,
          cssClass:
            this.baseView.mode != "review"
              ? "gc-editable-cell-color"
              : undefined,
          setCellValue: (newData, value, currentRowData) => {
            const newKernelValue = value || 0;
            const oldKernelValue = currentRowData.KernelVolume || 0;

            newData.KernelVolume = newKernelValue;

            // distribute to size columns based on previous percentages
            if (oldKernelValue > 0 && newKernelValue !== oldKernelValue) {
              // Calculate distribution based on previous percentages
              this.sizeColumns.forEach((col) => {
                const sizeCode = col.dataField;
                if (currentRowData[sizeCode] === undefined) return; // skip if size column does not exist in current row data
                const oldSizeValue = currentRowData[sizeCode] || 0;
                const percentage = oldSizeValue / oldKernelValue;
                const newSizeValue = newKernelValue * percentage;
                // Only set if value is greater than 0, otherwise set to null
                newData[sizeCode] = newSizeValue > 0 ? newSizeValue : null;
              });
            }
            newData.TotalKg = (currentRowData.Inshell || 0) + newKernelValue;

            this.updateTotalKgs(currentRowData.TotalKg, newData.TotalKg);
            return newData;
          },
        },
        {
          caption: "Total",
          dataField: "TotalKg",
          dataType: "number",
          allowEditing: false,
          minWidth: 110,
          format: "##,###,###,###,##0",
          editorOptions: {
            format: "##,###,###,###,##0",
          },
        },
      ].concat(this.columns);
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          cssClass: "header-form-items",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "EstimateSeason",
                  dataField: "Season",
                  editorType:
                    this.baseView.mode == "review"
                      ? "dxTextBox"
                      : "dxSelectBox",
                  required: true,
                  editorOptions: {
                    tabIndex: 2,
                    dataSource: IntakeSeasonService.dataSourceConfig(
                      "api/AlmondcoIntakeSeason",
                      {
                        select: ["Season", "RecordId", "StartDate", "EndDate"],
                        sort: "Season asc",
                      }
                    ),
                    displayExpr: "Season",
                    valueExpr: "Season",
                    searchExpr: (item) => String(item.Season),
                    searchMode: "contains",
                    showClearButton: true,
                    searchEnabled: true,
                    dropDownOptions: {
                      width: 150,
                    },
                    onFocusIn: (e) => {
                      if (e.event.target.select) e.event.target.select();
                    },
                    onItemClick: this.onSeasonClicked,
                    onValueChanged: (e) => {
                      this.onSeasonValueChanged(e);
                    },
                  },
                },
                {
                  screenField: "EstimateDate",
                  dataField: "EstimateDate",
                  required: true,
                  editorOptions: {
                    onFocusIn: (e) => {
                      if (e.event.target.select) e.event.target.select();
                    },
                    tabIndex: 3,
                  },
                },

                {
                  screenField: "TotalKg",
                  dataField: "TotalTons",
                  label: {
                    text: "Total Tonnes",
                  },
                  editorType: "dxNumberBox",
                  format: "##,###,###,###,##0.00",
                  editorOptions: {
                    format: "##,###,###,###,##0.00",
                    tabIndex: -1,
                    readOnly: true,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  dataField: "Narration",
                  cssClass: "narration-text-area",
                  label: {
                    text: "Narration",
                  },
                  editorType: "dxTextArea",
                  editorOptions: {
                    maxLength: 1000,
                    height: 90,
                    tabIndex: 4,
                    onFocusIn: (e) => {
                      if (e.event.target.select) e.event.target.select();
                    },
                    onKeyDown: (e) => {
                      if (forwardTabbing(e)) {
                        e.event.preventDefault();
                        if (this.IsGridDataLoaded) {
                          this.moveCellFocus({ rowIndex: 0 }, "StartDate");
                        }
                      }
                    },
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    getHeaderToolbar() {
      return {
        audit: this.baseView.mode == "review",
        status: false,
        notes: false,
        save: true,
        toolbarFormItems: [
          {
            screenField: "EstimateDescription",
            dataField: "Description",
            editorOptions: {
              tabIndex: 1,
              placeholder: "Name",
              maxLength: 100,
              width: 500,
            },
            label: {
              text: "Name",
              visible: false,
            },
            required: true,
            visible: this.baseView.mode != "review",
          },
        ],
        ellipsis:
          this.baseView.mode == "edit"
            ? {
                menuItems: [{ menuText: "Apply Size Profile" }],
                visible: true,
                clickAction: (e) => {
                  if (e.itemData.menuText == "Apply Size Profile") {
                    this.openApplySizeProfile();
                  }
                },
              }
            : undefined,

        formContentReady: (e) => {
          if (e && this.baseView.mode !== "review" && this.loaded)
            setTimeout(() => {
              var headerToolBarForm = e.component;
              if (headerToolBarForm && headerToolBarForm.getEditor("Name"))
                headerToolBarForm.getEditor("Name").instance().focus();
            }, 500);
        },
      };
    },

    getPopupConfig() {
      if (this.baseView.mode === "review") {
        return {
          formMode: "review",
        };
      }
      return undefined;
    },
  },
};
</script>

<style lang="scss">
.intake-estimate {
  .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row .dx-editor-cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
  .gc-editable-cell-color[role="gridcell"]:not(.cell-disabled) {
    background-color: #f8fdfe !important;
    // #d1f7ffba !important
  }

  .dx-row.dx-data-row {
    .editable-date-cell {
      .dx-texteditor.dx-editor-underlined .dx-placeholder::before {
        padding: unset !important;
      }
    }

    .gc-grid-button-column {
      .dx-icon {
        cursor: pointer;
      }
    }
  }

  .narration-text-area {
    > label.dx-field-item-label {
      padding-top: 8px;
    }
  }
}
</style>
